import Button from '../content/ButtonPlugin';

export default Button;
